import {useEffect, useState} from 'react';
import {routeModelData} from '../services/ModelService';
import {values} from 'lodash';

export default function useAllRoutes() {
    const [allRoutes, setAllRoutes] = useState(null);
    const [allRoutesArray, setAllRoutesArray] = useState(null);

    useEffect(() => {
        const loadRoutes = async () => {
            try {
                const routes = await routeModelData.getAll();
                setAllRoutes(routes);
            } catch (error) {
                console.error('Error loading routes:', error);
            }
        };

        loadRoutes();
    }, []);

    useEffect(() => {
        if (!allRoutes) return;
        setAllRoutesArray(values(allRoutes));
    }, [allRoutes, setAllRoutesArray]);

    return {
        allRoutes, allRoutesArray
    };
}